import { ReactNode } from 'react';
import { type Atom, useSelector } from '@tanstack/react-store';

interface IDataTableTopGroupProps {
    /** id строки группы, уехавшей за туллбар или шапку; null — копия не нужна */
    atom: Atom<string | null>;
    children: (rowId: string) => ReactNode;
}

/** Копия верхней группы со своей подпиской: смена группы при прокрутке перерисовывает только её, а не таблицу. */
const DataTableTopGroup = ({ atom, children }: IDataTableTopGroupProps) => {
    const rowId = useSelector(atom);
    return rowId ? children(rowId) : null;
};

export default DataTableTopGroup;
